/**
 * RNG gieo hạt được (mulberry32) — deterministic cho test và mô phỏng.
 * Mọi ngẫu nhiên trong core đều đi qua HamRng được inject, không dùng
 * Math.random trực tiếp (để sim/test lặp lại được).
 */

/** Hàm sinh số ngẫu nhiên trong [0, 1). */
export type HamRng = () => number;

/** Tạo RNG từ hạt số nguyên. */
export function taoRng(hat: number): HamRng {
  let a = hat >>> 0;
  return (): number => {
    a |= 0;
    a = (a + 0x6d2b79f5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

/**
 * Số lượt nguyên từ kỳ vọng thực: phần nguyên + Bernoulli(phần lẻ).
 * Dùng cho lượt khách/giờ khi kỳ vọng không nguyên (ví dụ 2,25).
 */
export function soLuotNgauNhien(kyVong: number, rng: HamRng): number {
  if (kyVong <= 0) return 0;
  const nguyen = Math.floor(kyVong);
  return nguyen + (rng() < kyVong - nguyen ? 1 : 0);
}

/** Xáo trộn mảng (Fisher–Yates) — trả mảng mới. */
export function xaoTron<T>(mang: readonly T[], rng: HamRng): T[] {
  const ketQua = [...mang];
  for (let i = ketQua.length - 1; i > 0; i--) {
    const j = Math.floor(rng() * (i + 1));
    const tam = ketQua[i]!;
    ketQua[i] = ketQua[j]!;
    ketQua[j] = tam;
  }
  return ketQua;
}
